module.exports = __webpack_public_path__ + "img/材料力学5_12.0e2c15da.jpg";